var _rect, _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyImagePurple = function SvgEmptyImagePurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 140 140"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 139,
    x: 0.5,
    y: 0.5,
    fill: "#F5F3FF",
    stroke: "#E7E5FF",
    rx: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E5FF",
    stroke: "#E7E5FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.331,
    d: "m37.311 103.47.641-5.47.641 5.47a3.18 3.18 0 0 0 2.662 2.77l3.15.498-3.15.497a3.18 3.18 0 0 0-2.662 2.77l-.64 5.47-.642-5.47a3.18 3.18 0 0 0-2.661-2.77l-3.15-.497 3.15-.498a3.18 3.18 0 0 0 2.661-2.77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E5FF",
    stroke: "#E7E5FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.056,
    d: "m43.466 46.812.29-2.479.29 2.479a1.44 1.44 0 0 0 1.207 1.254l1.427.226-1.427.225a1.44 1.44 0 0 0-1.206 1.255l-.29 2.478-.291-2.478a1.44 1.44 0 0 0-1.206-1.255l-1.427-.225 1.427-.226a1.44 1.44 0 0 0 1.206-1.255"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E5FF",
    stroke: "#E7E5FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.622,
    d: "m89.21 28.305.445-3.805.446 3.805a2.21 2.21 0 0 0 1.852 1.927l2.19.346-2.19.347a2.21 2.21 0 0 0-1.852 1.927l-.446 3.805-.446-3.805a2.21 2.21 0 0 0-1.851-1.927l-2.191-.347 2.19-.346a2.21 2.21 0 0 0 1.852-1.927M105.543 84.305l.446-3.805.446 3.805a2.21 2.21 0 0 0 1.851 1.927l2.191.346-2.191.347a2.21 2.21 0 0 0-1.851 1.927l-.446 3.805-.446-3.805a2.21 2.21 0 0 0-1.852-1.927l-2.191-.347 2.191-.346a2.21 2.21 0 0 0 1.852-1.927"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empty-image-purple_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#BFBAFE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M80.5 65.334 72.332 73.5M78.166 79.334 68.15 69.317a2.333 2.333 0 0 0-3.3 0l-5.35 5.35"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BFBAFE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M74.796 59.209h-9.593a5.996 5.996 0 0 0-5.995 5.995v9.593a5.996 5.996 0 0 0 5.995 5.996h9.593a5.996 5.996 0 0 0 5.996-5.996v-9.593a5.996 5.996 0 0 0-5.996-5.995"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBAFE",
    d: "m71.507 64.51.002-.002a1.167 1.167 0 1 1-.002.002"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empty-image-purple_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56 56h28v28H56z"
  })))));
};
export default SvgEmptyImagePurple;